export default __webpack_public_path__ + "static/media/gw.f6486c90.png";